import React from "react";
import { Spinner } from "reactstrap";

export default function Loader(props){
    const {text="Loading...", color} = props;
    return <div className='position-absolute d-flex justify-content-center align-items-center flex-column rounded w-100 h-100' style={{zIndex: 10, top: 0, left: 0}}>
    <Spinner color={color} />
    <div>{text}</div>
  </div>
}